import { TermsService } from './terms.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.sass'],
})
export class TermsComponent implements OnInit {
  
  constructor(public termsService: TermsService) { }

  async ngOnInit(): Promise<void> {
    if (this.termsService.terms === '') {
      await this.termsService.getTerms();
    }
  }

  public closeTerms(): void {
    this.termsService.showTerms = false;
  }
}